














































import { Component, Vue, Watch } from 'vue-property-decorator';
import Search from './Search.vue';
import Language from './Language.vue';
import { TimelineLite } from 'gsap/TweenMax';

@Component({
  components: {
    Search,
    Language,
  },
})
export default class Header extends Vue {
  // initial data
  private initItem: any = null;

  @Watch('$route')
  private onRouteChanged(to: any) {
    const line = (to && to.meta && to.meta.line) || 'home';
    this.initLine(line);
  }

  // lifecycle hook
  private mounted() {
    const line =
      (this.$route && this.$route.meta && this.$route.meta.line) || 'home';
    this.initLine(line);
  }

  private initLine(line: string) {
    this.initItem = this.$refs[line];
    this.resetLine(false);
  }

  private moveLine(e: MouseEvent) {
    const $curElement: any = e.target;

    const rect = $curElement.getBoundingClientRect();
    this.setLine(rect.left, rect.width);
  }

  private resetLine(withAnimation: boolean = true) {
    const rect = this.initItem.$el.getBoundingClientRect();
    this.setLine(rect.left, rect.width, withAnimation);
  }

  private setLine(left: number, width: number, withAnimation: boolean = true) {
    // $linebox $el
    const $linebox: any = this.$refs.linebox;

    if ($linebox.style.left !== `${left}px`) {
      if (withAnimation) {
        const t1 = new TimelineLite();
        t1.to(
          $linebox, // 操作对象
          0.3, // 动画持续时间
          {
            left,
            width,
          },
        );
      } else {
        $linebox.style.left = `${left}px`;
        $linebox.style.width = `${width}px`;
      }
    }
  }
}
